import { IRoute } from "../../../routes/types";

export const LAYOUT_STORED_MENU = "LAYOUT_STORED_MENU";
export const LAYOUT_STORED_SUBMENU = "LAYOUT_STORED_SUBMENU";
export enum EPrivateRouteType {
  ITEM = "SINGLE",
  DROPDOWN = "DROPDOWN",
}

export interface IMenuList {
  /** @deprecated Prefer moduleIcon semantic key */
  urlIcon?: string;
  /** Semantic Lucide module key (e.g. "explore") — preferred */
  moduleIcon?: string;
  iconSize?: number;
  name: string;
  route?: IRoute;
  type: EPrivateRouteType;
  children?: IMenuList[];
  beta?: boolean;
  id?: string;
  render?: boolean;
}

export interface ISubMenuLists {
  [mainMenuListName: string]: IMenuList[];
}
